module.exports = __webpack_public_path__ + "static/media/pf12.f29da532.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf12.png
// module id = 2655
// module chunks = 0